import RocketIcon from "../../assets/icons/rocket-icon.svg";

const ContactDetailsSection = () => {
  return (
    <section className="lg:px-10 lg:mb-[100px] font-poppins">
      <div className="max-w-screen-xl mx-auto p-8 sm:p-12 rounded-xl lg:shadow-[4px_4px_32px_var(--background-blue-color)]">
        <div className="flex flex-col gap-12 md:flex-row justify-between">
          {/* Left Column */}
          <div className="space-y-4 w-full lg:w-[35%]">
            <img
              src={RocketIcon}
              alt="Rocket Icon"
              className="w-[40px] h-[40px] lg:w-[60px] lg:h-[60px]"
            />
            <h3 className="text-[24px] lg:text-[22px] xl:text-[32px] text-green font-semibold">
              Contact us
            </h3>
            <p className="text-[14px] lg:text-[22px] text-gray-600">
              <span className="font-bold text-[14px] lg:text-[20px]">
                Phone:
              </span>{" "}
              <a
                href="tel:+94774968756"
                className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
              >
                (+44) 115 846 2250
              </a>
            </p>
            <p className="text-[14px] lg:text-[22px] text-gray-600">
              <span className="font-bold text-[14px] lg:text-[20px]">
                Email:
              </span>{" "}
              <a
                href="mailto:roselea@gmail.com"
                className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
              >
                info@roseleacarehomes.com
              </a>
            </p>
            <p className="text-[14px] lg:text-[22px] text-gray-600">
              <span className="font-bold text-[14px] lg:text-[20px]">
                Address:
              </span>{" "}
              <a
                href="https://www.google.com/maps/search/?api=1&query=73+Loughborough+Road,+West+Bridgford,+Nottingham+NG2+7JX,+UK"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
              >
                73 Loughborough Road, West Bridgford, Nottingham NG2 7JX, UK
              </a>
            </p>
          </div>

          {/* Right Column - Google Maps */}
          <div className="w-full lg:w-[60%] h-[300px] lg:h-[400px]">
            <iframe
              title="Location Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1980.1234567890123!2d-1.2345678901234567!3d52.123456789012345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4879b12345678901%3A0x1234567890123456!2s73%20Loughborough%20Road%2C%20West%20Bridgford%2C%20Nottingham%20NG2%207JX%2C%20UK!5e0!3m2!1sen!2suk!4v1612345678901"
              className="w-full h-full rounded-lg shadow-lg"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactDetailsSection;
